import Resource from './base.resource'

export default class DrawersResource extends Resource
{
    constructor() {
        super('drawers')
    }
}
